/**
 * @fileoverview Spinner component.
 * @description This component displays a large spinner with a message.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 * @package PlayItNow
 * @module apps/front/components/SpinnerBig
 */
import { useTranslation } from '../contexts/I18nContext'
import '../styles/components.css'
/**
 * @summary Spinner component.
 * @param {string} message - The message to display.
 * @returns {React.ReactNode} The spinner component.
 */
export const SpinnerBig = ({ message }: { message?: string }) => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-center min-h-100 text-white  ">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-(--color-white) "></div>
        <p className="mt-4 text-white ">{message || t('common.loading')}</p>
      </div>
    </div>
  )
}
